import React, { useCallback, useEffect } from "react";

import { useBuildUrl } from "routes/hooks";

import useCurrentUser from "data/advisor/useCurrentUser";
import useRedirect from "data/hub/hooks";

import Loading from "components/Loading";

import { IFrameForm } from "..";
import { useWelcomeToHublyFeature } from "../hooks";

function BookingForm() {
  const user = useCurrentUser();
  const buildUrl = useBuildUrl();
  const redirect = useRedirect();
  const { loadingFeature, schedulingWidget } = useWelcomeToHublyFeature();

  const redirectToHub = useCallback(() => {
    redirect("/");
  }, [redirect]);

  useEffect(() => {
    if (!loadingFeature && !schedulingWidget?.formUrl) redirectToHub();
  }, [redirectToHub, loadingFeature, schedulingWidget]);

  if (loadingFeature || !schedulingWidget?.formUrl)
    return (
      <Loading
        active
        messages={[
          "Welcome to Hubly!",
          "Let's schedule your first booking call",
        ]}
      />
    );

  return (
    <IFrameForm
      formUrl={buildUrl(schedulingWidget?.formUrl, [
        ["name", user?.name],
        ["firstname", user?.firstName],
        ["lastname", user?.lastName],
        ["email", user?.email],
      ])}
      title="Booking Form"
      dismissMessage={schedulingWidget?.dismissMessage}
      validator={schedulingWidget?.validator}
      onDismiss={redirectToHub}
    />
  );
}

export default BookingForm;
